import React from 'react';
import { Section } from './ui/Section';
import { Heart } from 'lucide-react';
export function ProofSection() {
  return <Section bg="cream" data-id="element-193">
      <div className="max-w-3xl mx-auto text-center" data-id="element-194">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F59E0B]/20 rounded-full mb-6 text-[#EA580C]" data-id="element-195">
          <Heart size={32} fill="currentColor" data-id="element-196" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-[#422006] mb-6 leading-snug" data-id="element-197">
          Este sistema no nació en una escuela de cocina, nació en el caos real
          de una mamá que no tenía quién la ayudara.
        </h2>
        <p className="text-lg md:text-xl text-[#78350F] leading-relaxed" data-id="element-198">
          Al simplificar la toma de decisiones (solo 1 base, solo 3 ingredientes
          extra), eliminas la fatiga mental. En la primera semana, notarás que
          tu cocina está más limpia y tu nivel de estrés a las 6:30 PM ha bajado
          un 80%.
        </p>
      </div>
    </Section>;
}